import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import AttachDown from '@root/modules/Warehouse/Inquiry/components/attachment/AttachDown';
import Comment from '@root/modules/Warehouse/Inquiry/components/comment';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SComment } from '../interfaces';
import CommentAddCmt from './Comment/CommentAddCmt';
import CommentEdit from './Comment/CommentEdit';
import CmtToDownSell from './Comment/CommentToShowSell';

interface Props {
  setLoadingCmt?: boolean;
  statusSeller?: string;
  isParentUpdate?: Boolean;
}

const CommentSeller = ({ setLoadingCmt, statusSeller, isParentUpdate }: Props) => {
  const { productId }: any = useParams();
  const [listQuotationComment, setListQuotationComment] = useState<SComment[]>(
    []
  );
  const [myLastCommentSell, setLMyLastCommentSell] = useState<SComment>();

  const _getDataSell = useCallback(async () => {
    if (productId) {
      const comment = await InquiryServices.getQuoteComment(productId);
      const commentList = comment.data;
      setListQuotationComment(commentList);
      const lastComment: SComment = commentList.at(-1);
      if (lastComment?.owner === 'Seller') {
        setLMyLastCommentSell({
          ...lastComment,
          owner: 'Comment from Customer :'
        });
      }
    }
  }, [productId]);

  useEffect(() => {
    if (listQuotationComment) {
      setListQuotationComment(listQuotationComment);
    }
  }, [listQuotationComment]);

  useEffect(() => {
    _getDataSell();
  }, [_getDataSell]);

  /*------------open eedit------------*/
  const [openEditSell, setOpenEditSell] = useState(false);
  const [close, setClose] = useState(false);
  const [showDown, setShowDown] = useState(true);
  const [openAdComment, setOpenAddComment] = useState(false);
  const [showCre, setShowCre] = useState(true);

  const [openDownImg, setOpenDownImg] = useState(false);
  const handleOpenEditSell = () => {
    setClose(true);
    setShowDown(true);
  };
  return (
    <>
      <div style={{ display: 'flex', gap: '10px' }}>
        <div style={{ marginTop: '15px', width: '100%' }}>
          {listQuotationComment.map((item, index) => (
            <div key={index.toString()}>
              {item.owner === 'Seller' ? (
                <>
                  {myLastCommentSell ? (
                    <>
                      {index === listQuotationComment.length - 1 ? (
                        <>
                          {showDown && (
                            <CmtToDownSell
                              setOpenEditSell={setOpenEditSell}
                              setShowDown={setShowDown}
                              listClone={myLastCommentSell}
                              setOpenDownImg={setOpenDownImg}
                              statusSeller={statusSeller}
                              isParentUpdate={isParentUpdate}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          <div style={{ display: 'flex', gap: '10px' }}>
                            <AttachDown
                              label={item.owner}
                              documents={item.documents}
                            />
                            <Comment
                              title={item.owner}
                              date={item.created_at}
                              content={item.comment}
                              btnText=""
                            />
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <AttachDown
                          label={item.owner}
                          // btnTitle="Upload"
                          documents={item.documents}
                        />
                        <Comment
                          title={item.owner}
                          date={item.created_at}
                          content={item.comment}
                          btnText=""
                        />
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div style={{ display: 'flex', gap: '10px' }}>
                  <AttachDown label={item.owner} documents={item.documents} />
                  <Comment
                    title={item.owner}
                    date={item.created_at}
                    content={item.comment}
                  />
                </div>
              )}
            </div>
          ))}

          {!myLastCommentSell?.documents && (
            <CommentAddCmt
              productId={productId}
              onSubmitted={() => {
                _getDataSell();
                setOpenEditSell(false);
                setClose(false);
                setShowDown(true);
              }}
              statusSeller={statusSeller}
            />
          )}

          {openEditSell && (
            <CommentEdit
              productId={productId}
              onSubmitted={() => {
                setOpenEditSell(false);
                setShowDown(true);
                setClose(false);
                _getDataSell();
              }}
              comment={myLastCommentSell!}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CommentSeller;
